<template>
  <span>
    <svg :class='[{ expired: isExpired(expiresAt) }, name.toLowerCase() ]' width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <circle cx="5" cy="5" r="5" fill="currentColor"></circle>
    </svg>

    <span class='plan-name'>{{ name }}</span>
    ({{ isExpired(expiresAt) ? 'expired' : 'active' }})
  </span>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'PlanDetails',
  methods: {
    isExpired(expiryDate) {
      return dayjs(expiryDate).isBefore(dayjs())
    }
  },
  props: ['name', 'expiresAt']
}
</script>

<style scoped lang="stylus">
.plan-name {
  text-transform: capitalize;
}

svg {
  margin-right: $spacingSm;

  &.expired {
    color: $grey
  }

  &:not(.expired) {
    color: $orange
  }

  &.customer:not(.expired), &.paid:not(.expired) {
    color: $green
  }
}
</style>
